$("header #menu-icon").on("click", function() {
    return $(".navbar").toggleClass("expand"),$("body").toggleClass("expand"),!1
});

$('body').click(function(){
    $(".navbar").removeClass("expand");
    $(this).removeClass("expand");
});

var $radioButtons = $('.remembermeacc input[type="radio"]'); 

$radioButtons.click(function() {
  $('.remembermeacc li').removeClass('active');

  let curent_variant_title = $(this).parents('li').data('variant-title');
  let current_size_info = $('.current_size_info');

  if (curent_variant_title !== null && curent_variant_title !== undefined) {
    if (curent_variant_title !== null && curent_variant_title !== undefined) {
      current_size_info.text(curent_variant_title);
    }
  }

  $(this).parents('li').addClass('active');
  $radioButtons.each(function() { 
    $(this).parents('li').toggleClass('radio_checked', this.checked); 
  }); 
});

$(document).on('change', '.product_select-wrapper select', function() {
  var variantTitle = $(this).find('option:selected').data('title');
  let current_size_info = $('.current_size_info');
  if (variantTitle !== null && variantTitle !== undefined) {
      current_size_info.text(variantTitle);
  }
});

$('#addtocart').on('click', function(e) {
  e.preventDefault();

  if(window.SLIDECART) {
    window.SLIDECART_OPEN();
  } else {
    window.location.href = "/cart";
  }
});

$('.add-me-to-cart').on('click', function(e){
  e.preventDefault();
  fetch('/cart.js', { method: "GET" })
  .then(async (res) => {
      window.cart_response = await res.json();
      window.__added_variant_ids = window.cart_response['items'].map(x => x['id']);
      // window.added_variant_id = $("input:radio[name=option]:checked").val();
      window.added_variant_id = $('.vairant-list li.active').data('variant-id');
      if(!window.__added_variant_ids.includes(+window.added_variant_id))
      {
          if(typeof window.SLIDECART_STATE === 'function')
          {
              addProductToCart(window.added_variant_id);
          }
      }
      else {
          window.SLIDECART_OPEN();
      }
  })
});

function addProductToCart(id)
{
  var addData = {
    'id': id,
    'quantity': 1
  };
  
    $("#overlay-adc").fadeIn(300);
  
    fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }).then(res => {
        SLIDECART_UPDATE();
        setTimeout(function () {
            $("#overlay-adc").fadeOut(300);
            window.SLIDECART_OPEN();
        }, 250);
    }).catch(function(err) {
    $("#overlay-adc").fadeOut(300);
    console.error(err)
  });
}